import { gql } from "@apollo/client";

export const getMyDashboardLayoutQuery = gql`
query($dashboard: String){
  getMyDashboardLayout(dashboard: $dashboard){
    response
    message
  }
}
`;

export const saveMyDashboardLayoutMutation = gql`
mutation($tileOrder: [String!]!, $dashboard: String){
  saveMyDashboardLayout(tileOrder: $tileOrder, dashboard: $dashboard){
    response
    message
  }
}
`;

// the dashboards this user built (Operations, Finance, ...) - `saved: false` = none yet, show the defaults
export const getMyDashboardsQuery = gql`
query{
  getMyDashboards{
    response
  }
}
`;

export const saveMyDashboardsMutation = gql`
mutation($dashboards: JSON!, $defaultId: String){
  saveMyDashboards(dashboards: $dashboards, defaultId: $defaultId){
    response
  }
}
`;

// figures for the widgets with no query of their own (on holiday, holiday requests, pay & bill, invoices)
export const getDashboardWidgetQuery = gql`
query($widget: String!, $startDate: String, $endDate: String){
  getDashboardWidget(widget: $widget, startDate: $startDate, endDate: $endDate){
    response
  }
}
`;
